<template>
  <v-card
    outlined
    tile
  >
    <v-card-text>
      <v-row>
        <!-- 画像 -->
        <v-col cols="12">
          <v-img
            :src="car.image"
            :aspect-ratio="16/9"
          />
        </v-col>

        <!-- サマリ -->
        <v-col cols="12">
          <!-- 車両名 -->
          <div class="caption">{{car.maker}}</div>
          <div>{{car.name}}</div>
          <div class="mt-4">
            <span>{{car.typeName}}</span>
            <span class="ml-4">{{summary}}</span>
          </div>
          <div>{{tags}}</div>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn text @click="book">選択する</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { run } from '@/libs/a'

export default {
  name: 'CCarCard',
  props: {
    car: {
      type: Object,
      required: true
    }
  },
  computed: {
    summary () {
      const summary = []

      const attrs = this.car.attributes

      if (attrs.cc > 0) {
        summary.push(`${attrs.cc / 1000} L`)
      }
      if (attrs.fuel) {
        summary.push(attrs.fuel)
      }
      if (attrs.seats > 0) {
        summary.push(`乗車${attrs.seats}名`)
      }
      if (attrs.bed > 0) {
        summary.push(`就寝${attrs.bed}名`)
      }

      return summary.join(' / ')
    },

    tags () {
      const tags = []

      const attrs = this.car.attributes

      tags.push(attrs.smoke ? '喫煙' : '禁煙')
      tags.push(attrs.drive ? '4WD' : '2WD')
      tags.push(attrs.mission ? 'MT' : 'AT')
      if (attrs.etc) {
        tags.push('ETC')
      }
      if (attrs.navi) {
        tags.push('カーナビ')
      }
      if (attrs.studless) {
        tags.push('スタッドレス可')
      }
      tags.push(...attrs.tags)
      if (attrs.keykey) {
        tags.push('キーロッカー対応')
      }

      return tags.join(' / ')
    }
  },

  methods: {
    book () {
      run(async () => {
        // 選択した車両を保存する
        await this.dispatch('book/setCar', this.car)

        // 次のページに移動する
        this.goTo({ name: 'book/options' })
      })
    }
  }
}
</script>
